var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carregando"},[_c('div',{staticClass:"carregando-posicao"},[_c('div',{staticClass:"carregando-circulo"},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","model-value":"20","size":70,"width":10}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }